// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2HLH0","productName":"Table_productName__1juQA"};